export const products = [
  {
    id: "niuhaha-children-original",
    name: "牛哈哈儿童原味牛奶片",
    brand: "牛哈哈",
    category: "children",
    categoryName: "儿童牛奶片",
    image: "https://readdy.ai/api/search-image?query=White%20milk%20tablet%20product%20on%20clean%20white%20background%20with%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20minimalist%20packaging%20design%2C%20warm%20tone%2C%20professional%20commercial%20photography&width=800&height=800&seq=milk-tablet-01&orientation=squarish",
    rating: 4.8,
    reviewCount: 2356,
    price: 39.9,
    calciumContent: "280mg/100g",
    description: "精选新西兰进口奶源，0添加蔗糖，专为3-12岁儿童研发。口感细腻，奶香浓郁，是宝宝最爱的营养零食。",
    features: ["新西兰进口奶源", "0添加蔗糖", "高钙配方", "独立小包装"],
    tags: ["热销", "口碑推荐"],
    slug: "niuhaha-children-original",
  },
  {
    id: "mengchun-high-calcium",
    name: "萌纯高钙牛奶片",
    brand: "萌纯",
    category: "high-calcium",
    categoryName: "高钙牛奶片",
    image: "https://readdy.ai/api/search-image?query=High%20calcium%20milk%20tablet%20packaging%20on%20light%20cream%20background%2C%20clean%20minimalist%20product%20photography%2C%20soft%20shadows%2C%20premium%20food%20supplement%20product%20shot%2C%20warm%20neutral%20tones&width=800&height=800&seq=milk-tablet-02&orientation=squarish",
    rating: 4.9,
    reviewCount: 4120,
    price: 59.0,
    calciumContent: "520mg/100g",
    description: "每片含钙量高达520mg，采用微囊化钙技术，吸收率提升40%。适合中老年人、孕妇及高强度运动人群。",
    features: ["微囊化钙技术", "吸收率提升40%", "零添加防腐剂", "天然乳钙来源"],
    tags: ["销量冠军", "专家推荐"],
    slug: "mengchun-high-calcium",
  },
  {
    id: "australia-gold-milk-tablet",
    name: "澳洲金装牛奶片",
    brand: "AussieGold",
    category: "imported",
    categoryName: "进口牛奶片",
    image: "https://readdy.ai/api/search-image?query=Premium%20imported%20Australian%20milk%20tablet%20in%20gold%20packaging%20on%20white%20marble%20surface%2C%20luxury%20product%20photography%2C%20clean%20elegant%20composition%2C%20soft%20natural%20light%2C%20professional%20commercial%20shot&width=800&height=800&seq=milk-tablet-03&orientation=squarish",
    rating: 4.7,
    reviewCount: 1890,
    price: 128.0,
    calciumContent: "380mg/100g",
    description: "100%澳洲原装进口，源自维多利亚州黄金牧场。每一颗牛奶片都经过12道工序精制，奶香纯正浓郁。",
    features: ["澳洲原装进口", "黄金牧场奶源", "12道精制工艺", "无人工色素"],
    tags: ["进口优选", "品质之选"],
    slug: "australia-gold-milk-tablet",
  },
  {
    id: "little-cow-probiotic",
    name: "小奶牛益生菌牛奶片",
    brand: "小奶牛",
    category: "probiotic",
    categoryName: "益生菌牛奶片",
    image: "https://readdy.ai/api/search-image?query=Cute%20cow%20themed%20probiotic%20milk%20tablet%20packaging%20on%20soft%20pastel%20green%20background%2C%20friendly%20product%20photography%2C%20warm%20natural%20lighting%2C%20clean%20minimalist%20composition&width=800&height=800&seq=milk-tablet-04&orientation=squarish",
    rating: 4.6,
    reviewCount: 1530,
    price: 49.9,
    calciumContent: "300mg/100g",
    description: "每片添加50亿活性益生菌，乳双歧杆菌+嗜酸乳杆菌双重配方，好吃又护肠，孩子爱上喝奶的感觉。",
    features: ["50亿活性益生菌", "双重益生菌配方", "草莓味", "无防腐剂"],
    tags: ["肠道健康", "宝宝最爱"],
    slug: "little-cow-probiotic",
  },
  {
    id: "pure-milk-sugar-free",
    name: "纯甄无糖牛奶片",
    brand: "纯甄",
    category: "sugar-free",
    categoryName: "无糖牛奶片",
    image: "https://readdy.ai/api/search-image?query=Sugar%20free%20healthy%20milk%20tablet%20with%20green%20natural%20packaging%20on%20clean%20white%20background%2C%20organic%20feel%20product%20photography%2C%20soft%20daylight%2C%20minimalist%20healthy%20food%20product%20shot&width=800&height=800&seq=milk-tablet-05&orientation=squarish",
    rating: 4.7,
    reviewCount: 2010,
    price: 45.0,
    calciumContent: "320mg/100g",
    description: "使用天然赤藓糖醇代替蔗糖，零GI，糖尿病人也能放心享用。口感清甜不腻，是控糖人士的理想选择。",
    features: ["零蔗糖", "赤藓糖醇代糖", "零GI值", "糖尿病人适用"],
    tags: ["控糖推荐", "健康之选"],
    slug: "pure-milk-sugar-free",
  },
  {
    id: "little-cow-adult-original",
    name: "小奶牛成人原味牛奶片",
    brand: "小奶牛",
    category: "adult",
    categoryName: "成人牛奶片",
    image: "https://readdy.ai/api/search-image?query=Adult%20milk%20tablet%20product%20in%20modern%20minimalist%20packaging%20on%20clean%20light%20grey%20background%2C%20professional%20product%20photography%2C%20warm%20studio%20lighting%2C%20premium%20food%20supplement%20shot&width=800&height=800&seq=milk-tablet-06&orientation=squarish",
    rating: 4.5,
    reviewCount: 1280,
    price: 35.0,
    calciumContent: "260mg/100g",
    description: "专为成人打造的大分量牛奶片，奶香纯正。适合办公室零食、健身补给、户外旅行携带，随时随地补充营养。",
    features: ["大分量装", "原味口感", "便携包装", "高性价比"],
    tags: ["日常必备", "性价比"],
    slug: "little-cow-adult-original",
  },
  {
    id: "niuhaha-children-strawberry",
    name: "牛哈哈儿童草莓味牛奶片",
    brand: "牛哈哈",
    category: "children",
    categoryName: "儿童牛奶片",
    image: "https://readdy.ai/api/search-image?query=Pink%20strawberry%20flavored%20children%20milk%20tablet%20packaging%20on%20soft%20pink%20background%2C%20cute%20playful%20product%20photography%2C%20warm%20lighting%2C%20clean%20minimalist%20kids%20product%20shot&width=800&height=800&seq=milk-tablet-07&orientation=squarish",
    rating: 4.8,
    reviewCount: 3100,
    price: 42.9,
    calciumContent: "270mg/100g",
    description: "在经典配方基础上加入天然草莓粉，酸甜可口，是挑食宝宝的救星。独立小包装设计，方便携带不粘手。",
    features: ["天然草莓粉", "酸甜口感", "独立小包装", "0添加色素"],
    tags: ["人气爆款", "挑食救星"],
    slug: "niuhaha-children-strawberry",
  },
  {
    id: "newzealand-pure-milk-tablet",
    name: "新西兰纯净牛奶片",
    brand: "NatureDairy",
    category: "imported",
    categoryName: "进口牛奶片",
    image: "https://readdy.ai/api/search-image?query=New%20Zealand%20imported%20pure%20milk%20tablet%20in%20green%20nature%20inspired%20packaging%20on%20clean%20white%20surface%2C%20fresh%20natural%20product%20photography%2C%20soft%20diffused%20light%2C%20premium%20dairy%20product%20shot&width=800&height=800&seq=milk-tablet-08&orientation=squarish",
    rating: 4.9,
    reviewCount: 890,
    price: 158.0,
    calciumContent: "410mg/100g",
    description: "源自新西兰南岛纯净牧场，全年草饲奶牛所产鲜奶制成，通过了新西兰MPI和中国海关双重检疫认证。",
    features: ["新西兰南岛牧场", "草饲奶牛", "双重检疫认证", "有机认证"],
    tags: ["高端之选", "有机认证"],
    slug: "newzealand-pure-milk-tablet",
  },
];

export const getProductsByCategory = (categorySlug: string) => {
  return products.filter((p) => p.category === categorySlug);
};

export const getProductBySlug = (productSlug: string) => {
  return products.find((p) => p.slug === productSlug) || null;
};